import React, { useEffect, useState } from 'react';
import { Box, Typography, Divider, List, ListItem, Button, Avatar } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useActivityUtils } from './utilities/ActivityUtils';
import { useAuth } from './contexts/AuthContext';
import { useFirebase } from './contexts/FirebaseContext';
import { doc, getDoc } from 'firebase/firestore';
import dayjs from 'dayjs';
const ACCEPTED_TYPES = {
  INVITE: 'invite',
  ACTION_INVITED: 'action-invited',
  GAME_FINALISED: 'game-finalised',
  GAME_CONFIRMED: 'game-confirmed',
  GAME_SCORED: 'game-scored',
};
const Activity = () => {
  const navigate = useNavigate();
  const { db } = useFirebase();
  const [activityData, setActivityData] = useState([]);
  const { getActivitiesForUser } = useActivityUtils();
  const { currentUser } = useAuth();
  const [user, setUser] = useState(null);
  useEffect(() => {
    async function pullData() {
      if (currentUser) {
        const data = await getActivitiesForUser(currentUser.uid);
        console.log('setActivityData', data);
        setActivityData(data);
        const userData = await getDoc(doc(db, 'users', currentUser.uid));
        setUser(userData.data());
      }
    }

    pullData();
  }, [currentUser, getActivitiesForUser, db]);
  console.log('currentUser', currentUser);


  const getMessage = (item) => {
    if (item.type === ACCEPTED_TYPES.INVITE) {
      return (
        <>
          <strong>{item?.createdBy?.username}</strong> invited you to a game at{' '}
          <span
            onClick={(e) => {
              e.stopPropagation();
              handleLocation(item?.game);
            }}
            style={{
              textDecoration: 'underline',
              color: 'black',
              fontStyle: 'italic',
              cursor: 'pointer',
            }}
          >
            {item?.game?.clubName}
          </span>{' '}
          on {getListOfDatesFromGame(item?.game)}
        </>
      );
    }
    if (item.type === ACCEPTED_TYPES.ACTION_INVITED) {
      return (
        <>
          <strong>You</strong> invited <strong>{item?.createdBy?.username}</strong> to a game
        </>
      );
    }
    if (item.type === ACCEPTED_TYPES.GAME_FINALISED) {
      console.log('item', item);
      return (
        <>
          Your game at <strong>{item?.game?.clubName}</strong> has been finalised 💪, it will take
          place on{' '}
          <strong>{dayjs(item?.game?.date?.toDate()).format('dddd DD MMM [at] hh:mma')}</strong> 🗓️
        </>
      );
    }
    if (item.type === ACCEPTED_TYPES.GAME_CONFIRMED) {
      // TODO: handle local timezones properly
      return (
        <>
          <strong>{item?.createdBy?.username}</strong> confirmed the date of{' '}
          <strong>{dayjs(item?.game?.date?.toDate()).add(1, 'hour').format('dddd DD MMM [at] hh:mma')}</strong> for
          your game at <strong>{item?.game?.clubName}</strong>
        </>
      );
    }
    if (item.type === ACCEPTED_TYPES.GAME_SCORED) {
      return (
        <>
          Your game <strong>{item?.game?.name}</strong> has been scored 📝, view the scores now.
          <br />
          Remember to pay your dues 💴, or <strong>{item?.createdBy?.username}</strong> will be
          chasing you for a late payment fee. 😉
        </>
      );
    }
    return item.message;
  };

  const getButton = (item) => {
    if (item.game) {
      return (
        <Button
          variant="contained"
          style={{
            backgroundColor: '#475A44',
            whiteSpace: 'nowrap',
          }}
          onClick={() => {
            navigate(`/games/${item.game.id}`);
          }}
        >
          View Game
        </Button>
      );
    }
  };

  const handleLocation = (data) => {
    const url = data.clubLongitude
      ? `https://www.google.com/maps/search/?q=${data.clubLatitude},${data.clubLongitude}`
      : `https://www.google.com/maps/search/?q=${data.clubPostCode}`;
    window.open(url, '_blank');
  };

  const getListOfDatesFromGame = (game) => {
    if (!game?.dateTimeOptions?.length) return null;

    const formattedDates = game.dateTimeOptions.map((option) =>
      dayjs(option?.option?.toDate()).format('dddd DD MMM [at] hh:mma')
    );

    const dateElements = formattedDates.map((date, index) => {
      const isLast = index === formattedDates.length - 1;
      const isSecondLast = index === formattedDates.length - 2;

      return (
        <React.Fragment key={index}>
          <strong>{date}</strong>
          {!isLast && (isSecondLast ? ' or ' : ', ')}
        </React.Fragment>
      );
    });

    return (
      <>
        {formattedDates.length > 1 && 'either '}
        {dateElements}
      </>
    );
  };

  const renderAvatar = (item, index, isUrgent) => {
    const photoURL = item?.createdBy?.photoURL || currentUser?.photoURL;

    const commonStyles = {
      bgcolor: index % 2 === 0 ? '#E9FFEA' : '#F9EDFF',
      width: '48px',
      height: '50px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    };

    if (item.type === 'invite') {
      return photoURL ? (
        <Avatar
          variant={isUrgent ? 'urgentActivity' : 'activity'}
          src={photoURL}
          sx={commonStyles}
        />
      ) : (
        <Box
          sx={{
            bgcolor: index % 2 === 0 ? '#E9FFEA' : '#F9EDFF',
            width: '48px',
            height: '50px',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            borderRadius: '50%'
          }}
        >
          <Typography
            variant="factorA"
            component="small"
            sx={{
              fontSize: '16px',
              lineHeight: 1,
              color: '#4C4C4C',
              padding: 0,
              margin: 0,
            }}
          >
            {item?.createdBy?.initial}
          </Typography>
        </Box>
      );
    } else {
      return (
        <Avatar alt={item?.createdBy?.userName || item?.createdBy?.userId} sx={commonStyles}>
          <Typography
            variant="factorA"
            component="small"
            sx={{
              fontSize: '16px',
              lineHeight: 1,
              color: '#4C4C4C',
              padding: 0,
              margin: 0,
            }}
          >
            {user?.username?.charAt(0).toUpperCase()}
          </Typography>
        </Avatar>
      );
    }
  };

  // Activity item renderer
  const renderActivityItem = (item, index) => {
    const isPending = item.category === 'action';
    const isUrgent = isPending && item.urgent;
    const acceptedTypes = [...Object.values(ACCEPTED_TYPES)];
    if (!acceptedTypes.includes(item.type)) return null;
    return (
      <ListItem
        variant={isUrgent ? 'urgentActivity' : 'activity'}
        alignItems="flex-start"
        sx={{
          width: '100%',
          display: 'flex',
          justifyContent: 'space-between',
          alignContent: 'center',
          alignItems: 'center',
        }}
      >
        <Box sx={{ display: 'flex', flexGrow: 1, paddingTop: '10px' }}>
          <Box sx={{ width: '50px' }}>{renderAvatar(item)}</Box>
          <Box variant="activityContent" sx={{ ml: 2 }}>
            <Typography variant="activityMessage">{getMessage(item)}</Typography>
            <Box variant="activityFooter">
              <Typography variant="activityTime" color="text.secondary">
                {(() => {
                  const dayjs = require('dayjs');
                  const relativeTime = require('dayjs/plugin/relativeTime');
                  dayjs.extend(relativeTime);

                  const activityDate = dayjs.unix(item.timestamp.seconds);
                  return activityDate.fromNow();
                })()}
              </Typography>
            </Box>
          </Box>
        </Box>
        <Box sx={{ ml: 2 }}>{getButton(item)}</Box>
      </ListItem>
    );
  };

  return (
    // <Box variant="activityContainer">
    <div
      style={{
        width: '100%',
        padding: '20px',
        paddingLeft: '20px',
        paddingRight: '20px',
      }}
    >
      <Typography variant="h3" sx={{ mb: 1, ml: 2 }}>
        All Activity
      </Typography>
      <List sx={{ width: '100%' }}>
        {activityData.map((activity, index) => (
          <React.Fragment key={activity.id}>
            {renderActivityItem(activity, index)}
            {index < activityData.length - 1 && <Divider component="li" />}
          </React.Fragment>
        ))}
      </List>
    </div>
  );
};

export default Activity;
